import { gql } from 'graphql-tag';
export const CAROUSEL_DEEP_FRAGMENT = `
  fragment CarouselDeepFragment on Carousel {
    __typename
    id
    name
    displayCarded
    extendedImages
    slides {
      __typename
      id
      link
      ctaLink
      ctaText
      description
      cover {
        id
        src
      }
      overlayImage {
        id
        src
      }
      mobileImage {
        id
        src
      }
    }
  }
`;
export const CAROUSELS_GET = gql `
  ${CAROUSEL_DEEP_FRAGMENT}
  query {
    allCarousels {
      ...CarouselDeepFragment
    }
  }
`;
//# sourceMappingURL=carousel.js.map